import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import { AppointmentResponse, appointmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { isAttendanceAppointment } from "./appointmentCalendar.utils";

interface UseAppointmentsQueryParams {
  startDate: Date;
  endDate: Date;
  counselorId: string | null;
}

export function useAppointmentsQuery({ startDate, endDate, counselorId }: UseAppointmentsQueryParams) {
  const { data, isLoading } = useQuery<AppointmentResponse[]>({
    queryKey: [QueryKey.Appointments, startDate.toISOString(), endDate.toISOString(), counselorId],
    queryFn: () =>
      appointmentsApi.getAppointmentsByDate({
        startDate: startDate,
        endDate: endDate,
        assignedCounselorId: counselorId ?? undefined,
      }),
  });

  const { appointments, calendarAppointments, attendanceAppointments } = useMemo(() => {
    const appointments = data ?? [];
    return {
      appointments: appointments,
      calendarAppointments: appointments.filter((a) => !isAttendanceAppointment(a)),
      attendanceAppointments: appointments.filter(isAttendanceAppointment),
    };
  }, [data]);

  return { appointments, calendarAppointments, attendanceAppointments, isLoading };
}
